import APIService from './APIService';

export default {
  getPorRegional(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-por-regional/${tipo}`, {
      params
    });
  },

  getPorMunicipio(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-por-municipio/${tipo}`, {
      params
    });
  },

  getPorAlimentador(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-por-alimentador/${tipo}`, {
      params
    });
  },

  getTrafosPorPotencia(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-trafos-por-potencia/${tipo}`, {
      params
    });
  },

  getPorLocalizacao(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-por-localizacao/${tipo}`, {
      params
    });
  },

  getPorMaterial(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-por-material/${tipo}`, {
      params
    });
  },

  getPorUnidadeConsumidora(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-por-uc/${tipo}`, {
      params
    });
  },

  getPorTipoUnidade(tipo, params = {}) {
    return APIService.apiCall().get(`dashboard-quantitativo-graficos/get-por-tipo-unidade/${tipo}`, {
      params
    });
  }
};
